export default __webpack_public_path__ + "static/media/trending2.f753e233.png";